import React, { useState } from "react";
import "./index.scss";
import { Typography, IconButton } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { Icon } from "@iconify/react";
import SiTextField from "../../../../core/si-textfield";

const PlantDetails = ({ onSave, plantList, onDelete, error }) => {
  const [plantDetails, setPlantDetails] = useState({});
  const [addNew, setAddNew] = useState(false);

  const onInputChange = (event) => {
    setPlantDetails({
      ...plantDetails,
      [event.target.name]: event.target.value,
    });
  };

  const deleteRecord = (index) => {
    onDelete(index);
  };

  return (
    <div className="history-services">
      <div className="ph-header ">
        <p
          style={
            error
              ? {
                  color: "red",
                }
              : {}
          }
          className="primary-text"
        >
          Plant Details
        </p>
        <IconButton onClick={() => setAddNew(true)}>
          <Icon
            icon="lets-icons:add-duotone"
            width="2rem"
            height="2rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
      </div>
      {addNew && (
        <div className="plant-details-row fs-row ">
          <SiTextField
            name="plantName"
            placeholder="Plant Name"
            type="text"
            onChange={onInputChange}
            value={plantDetails.plantName || ""}
          />
          <SiTextField
            name="cutInDate"
            placeholder="Cut In Date"
            type="date"
            onChange={onInputChange}
            value={plantDetails.cutInDate || ""}
          />

          <SiTextField
            name="cutInNumber"
            placeholder="Cut In Number"
            type="text"
            onChange={onInputChange}
            value={plantDetails.cutInNumber || ""}
          />
          <div style={{ display: "flex", gap: "5px" }}>
            <IconButton
              disabled={
                !plantDetails.plantName ||
                !plantDetails.cutInDate ||
                !plantDetails.cutInNumber
              }
              onClick={() => {
                onSave(plantDetails);
                setAddNew(false);
                setPlantDetails({});
              }}
            >
              <CheckCircleOutlineOutlinedIcon />
            </IconButton>
            <IconButton onClick={() => setAddNew(false)}>
              <CancelOutlinedIcon />
            </IconButton>
          </div>
        </div>
      )}
      <div className="ph-table">
        {plantList.length > 0 && (
          <div className="pht-header table-header-bg primary-text plant-details-row">
            <span>Plant Name</span>
            <span>Cut In Date</span>
            <span>Cut In Number</span>
          </div>
        )}
        {plantList.map((item, index) => {
          return (
            <div className="pht-header plant-details-row" key={index}>
              <span>{item.plantName}</span>
              <span>{item.cutInDate}</span>
              <span>{item.cutInNumber}</span>

              <div className="actions">
                <IconButton
                  onClick={() => deleteRecord(index)}
                  sx={{ padding: "0px" }}
                >
                  <DeleteTwoToneIcon color="error" />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default PlantDetails;
